var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgQuestion = function SvgQuestion(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 8a7 7 0 1 0 14 0A7 7 0 1 0 1 8Zm6.465-.198C7.344 8.1 7.283 8.5 7.283 9h1.375l.021-.328c.04-.35.195-.657.467-.918l.436-.414c.34-.33.578-.628.714-.897.136-.272.204-.56.204-.864 0-.67-.21-1.187-.628-1.553-.42-.368-1.008-.553-1.768-.553-.751 0-1.346.194-1.783.58-.433.387-.653.922-.66 1.606h1.557c.007-.286.09-.51.247-.671.161-.165.375-.247.64-.247.558 0 .837.302.837.907 0 .201-.053.393-.16.575-.108.18-.325.414-.65.704-.323.286-.545.578-.667.875Zm-.093 2.934a.781.781 0 0 0-.242.591c0 .236.079.432.236.586.161.154.373.23.634.23s.47-.076.628-.23a.775.775 0 0 0 .242-.586.773.773 0 0 0-.247-.59A.854.854 0 0 0 8 10.5a.873.873 0 0 0-.628.236Z",
    fill: "#262D38"
  })));
};
export default SvgQuestion;